const fares = {
  toast: {
    error: {
      badResponse: '[Tarifa] respuesta incorrecta del servidor',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[Tarifa] Creada correctamente',
      },
      edit: {},
      delete: {
        default: '[Tarifa] eliminada correctamente',
      },
    },
  },
  createFareBtn: 'Crear',
  showBreakdownBtn: 'Mostrar desglose',
  total: 'Total: ',

  deleteModal: {
    header: 'Eliminar tarifas',
    body: 'Está a punto de eliminar {{num}} tarifas.',
  },

  table: {
    headers: {
      biDir: 'Bidireccional',
    },
    biDirOptions: {
      way2: '2 Vías',
      way1: '1-Vía',
    },
    actions: {
      delete: 'Eliminar',
      export: 'Exportar',
    },
  },

  fareTypeOptions: {
    Base: 'Base',
    Addition: 'Adición',
    Percent: 'Porcentaje',
    Total: 'Total',
  },

  additions: {
    value: 'Valor',
    valueType: 'Tipo de valor',
    name: 'Nombre',
    hour1: 'Hora de inicio',
    hour2: 'Hora de finalización',
    date1: 'Fecha de inicio',
    date2: 'Fecha de finalización',
    cancel: 'Cancelar',
    addAddition: 'Añadir suma',
    priority: 'Prioridad',
    weekDays: 'Días de la semana',
    newAddition: 'Nueva incorporación',
    price: 'Precio',
    total: 'Total',
    percent: 'Porcentaje',
    columnExist: 'El título ya existe',
  },

  create: {
    confirmButtonText: 'Confirmar',
    code: 'Código',
    from: 'De',
    to: 'Hacia',
    service: 'Servicios',
    select: 'Seleccionar',
    validations: {
      code: 'El código es obligatorio',
    },

    successToast: {
      message: '¡Éxito! Tarifa creada.',
    },
    errorToast: {
      message: '¡Ocurrió un error! No se pudo crear la tarifa',
    },
  },

  update: {
    code: 'Código',
    from: 'De',
    to: 'Hacia',
    service: 'Servicios',
    price: 'Precio',
    confirmButtonText: 'Actualizar',
    successMsg: 'Tarifa actualizada correctamente',

    successToast: {
      message: '¡Éxito! Tarifa actualizada correctamente.',
    },
    errorToast: {
      message: '¡Ocurrió un error! No se pudo actualizar la tarifa',
    },
  },

  validations: {
    code: {
      require: 'El código es obligatorio',
    },
    from: {
      require: 'De es obligatorio',
    },
    to: {
      require: 'Hacia es obligatorio',
    },
    service: {
      require: 'Se requiere servicio',
    },
    unit: {
      require: 'La unidad es obligatoria',
    },
    rateType: {
      require: 'El tipo de tarifa es obligatorio',
    },
  },
  forms: {
    header: {
      createFare: {
        title: 'Crear',
      },

      updateFare: {
        title: 'Actualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    information: {
      details: {
        header: 'Detalles de la tarifa',
        fields: {
          units: {
            name: 'Sitios',
          },
          name: {
            name: 'Nombre',
          },
          group: {
            name: 'Agrupar',
          },
          services: {
            name: 'Servicios',
          },
          biDirectional: {
            name: 'Direccional',
          },
          from: {
            name: 'De zona',
          },
          to: {
            name: 'Hacia zona',
          },
        },
      },
      mileage: {
        header: 'Millaje',
        fields: {
          distanceFrom: {
            name: 'Distancia desde',
          },
          distanceTo: {
            name: 'Distancia a',
          },
        },
      },
      conditions: {
        header: 'Condiciones',
        fields: {
          startDate: {
            name: 'Fecha de inicio',
          },
          endDate: {
            name: 'Fecha de finalización',
          },
          startHour: {
            name: 'Hora de inicio',
          },
          endHour: {
            name: 'Hora de finalización',
          },
          weekDays: {
            name: 'Días de semana',
          },
          fromDate: {
            name: 'De fecha',
          },
          toDate: {
            name: 'Hasta la fecha',
          },
        },
      },
    },
  },
};

export default fares;
